import React from 'react';
import { Badge } from 'react-bootstrap';

interface StateBadgeProps {
  state: string;
  className?: string;
}

const StateBadge: React.FC<StateBadgeProps> = ({ state, className = '' }) => {
  // Map state strings to badge colors
  const getBadgeColor = (state: string): string => {
    switch (state) {
      case 'Avaria':
        return 'danger';
      case 'avaria':
        return 'danger';

      case 'Acidente':
        return 'danger';
      case 'acidente':
        return 'danger';

      case 'Manutenção':
        return 'warning';
      case 'manutencao':
        return 'warning';

      case 'Inspeção':
        return 'warning';
      case 'inspecao':
        return 'warning';

      case 'Operacional':
        return 'primary';

      case 'Observação':
        return 'secondary';
      case 'observacao':
        return 'secondary';

      case 'Não operacional':
        return 'secondary';
      case 'nao operacional':
        return 'secondary';

      default:
        return 'primary';
    }
  };

  // Normalize old state values to new labels
  const getDisplayLabel = (state: string): string => {
    switch (state) {
      case 'observacao':
        return 'Observação';

      case 'avaria':
        return 'Avaria';

      case 'manutencao':
        return 'Manutenção';

      case 'inspecao':
        return 'Inspeção';

      case 'acidente':
        return 'Acidente';

      case 'Não operacional':
        return 'Manutenção';

      default:
        return state;
    }
  };

  return (
    <Badge bg={getBadgeColor(state)} className={`badge-fix ${className}`}>
      {getDisplayLabel(state)}
    </Badge>
  );
};

export default StateBadge;
